import React, { useEffect, useState } from "react";
import {
  generateRandomInvoiceNumber,
  getFormattedDate,
} from "../../resources/helper/helper";
import { useLocation } from "react-router-dom";

export default function Invoice() {
  const location = useLocation();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (location?.state) {
      setData(location?.state);
    }
  }, [location.state]);
  return (
    <div>
      <div className="invoice invoice-content invoice-3">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="invoice-inner">
                <div className="invoice-info" id="invoice_wrapper">
                  <div className="invoice-header">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="invoice-name">
                          <div className="logo">
                            <a>
                              <img
                                src="../..//assets/imgs/theme/logo.png"
                                alt="logo"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 text-end">
                        <div className="invoice-numb">
                          <h4 className="invoice-header-1 mb-10 mt-20">
                            Invoice No:{" "}
                            <span className="text-heading">
                              {generateRandomInvoiceNumber()}
                            </span>
                          </h4>
                          <h6>
                            Invoice Date:{" "}
                            <span className="text-heading">
                              {getFormattedDate()}
                            </span>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="invoice-top">
                    <div className="row">
                      <div className="col-lg-4 col-md-6">
                        <div className="invoice-number">
                          <h4 className="invoice-title-1 mb-10">Invoice To</h4>
                          <p className="invoice-addr-1">
                            <strong>Mall Sy Loo Inc</strong> <br />
                            205 North Nazimabad Avenue, Suite 810
                            <br />
                            karachi, 60601, PK
                            <br />
                            <abbr title="Phone">Phone:</abbr> (+123) 456-7890
                            <br />
                            <abbr title="Email">Email: </abbr>
                            contact@mallsylo.com
                            <br />
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="invoice-number">
                          <h4 className="invoice-title-1 mb-10">Bill To</h4>
                          <p className="invoice-addr-1">
                            <strong>
                              {data?.firstName} {data?.lastName}
                            </strong>{" "}
                            <br />
                            {data?.address}
                            <br />
                            <abbr title="Phone">Phone: </abbr>
                            {data?.phone}
                            <br />
                            <abbr title="Email">Email: </abbr>
                            {data?.email}
                            <br />
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="invoice-number">
                          <h4 className="invoice-title-1 mb-10">Overview</h4>
                          <p className="invoice-addr-1">
                            <strong>Invoice Data: </strong>
                            {generateRandomInvoiceNumber()}
                            <br />
                            <strong>Payment Method: </strong>{" "}
                            {data?.paymentType}
                            <br />
                            <strong>Status: </strong>
                            <span className="text-brand">
                              {data?.paymentType === "COD"
                                ? "Pending"
                                : "Completed"}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="invoice-center">
                    <div className="table-responsive">
                      <table className="table table-striped invoice-table">
                        <thead className="bg-active">
                          <tr>
                            <th>Item Item</th>
                            <th className="text-center">Unit Price</th>
                            <th className="text-center">Quantity</th>
                            <th className="text-right">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.products &&
                            data?.products?.length > 0 &&
                            data?.products?.map((item, index) => (
                              <tr>
                                <td>
                                  <div className="item-desc-1">
                                    <span>{item?.name}</span>
                                    <small>Category: {item?.category}</small>
                                  </div>
                                </td>
                                <td className="text-center">
                                  Rs. {item?.discount_price}
                                </td>
                                <td className="text-center">
                                  {item?.quantity}
                                </td>
                                <td className="text-right">
                                  Rs. {item?.discount_price * item?.quantity}
                                </td>
                              </tr>
                            ))}

                          {/* <tr>
                            <td colSpan={3} className="text-end f-w-600">
                              SubTotal
                            </td>
                            <td className="text-right">$1710.99</td>
                          </tr> */}
                          {/* <tr>
                            <td colSpan={3} className="text-end f-w-600">
                              Tax
                            </td>
                            <td className="text-right">$85.99</td>
                          </tr> */}
                          <tr>
                            <td colSpan={3} className="text-end f-w-600">
                              Grand Total
                            </td>
                            <td className="text-right f-w-600">
                              Rs. {data?.total}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="invoice-bottom">
                    <div className="row">
                      <div className="col-sm-6">
                        <div>
                          <h3 className="invoice-title-1">Important Note</h3>
                          <ul className="important-notes-list-1">
                            <li>
                              All amounts shown on this invoice are in Pakistani
                              Rupees.
                            </li>
                            <li>
                              finance charge of 1.5% will be made on unpaid
                              balances after 30 days.
                            </li>
                            <li>Once order done, money can't refund</li>
                            <li>
                              Delivery might delay due to some external
                              dependency
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-sm-6 col-offsite">
                        <div className="text-end">
                          <p className="mb-0 text-13">
                            Thank you for your business
                          </p>
                          <p>
                            <strong>MallSyLo</strong>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="invoice-btn-section clearfix d-print-none">
                  <a
                    className="btn btn-lg btn-custom btn-print hover-up"
                    href="javascript:window.print()"
                  >
                    <img src="assets/imgs/theme/icons/icon-print.svg" alt="" />
                    Print
                  </a>
                  <a
                    id="invoice_download_btn"
                    className="btn btn-lg btn-custom btn-download hover-up"
                  >
                    <img
                      src="assets/imgs/theme/icons/icon-download.svg"
                      alt=""
                    />
                    Download
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
